import {
  UIDAPresentationTypeEnum,
  UIDAStructureTypeEnum,
  KuxMenuItem,
  KuxFilteredCategoriesDTO,
  parseMenuItemFromCategory,
} from '@kaltura-ott/tvpil';
import { action, observable } from 'mobx';

import { errorHandling } from '../../../utils/error-handling';
import { CategoryChildren } from '../category-children';
import { CategoryStore } from '../category-store';
import { isNewSubtypeSupported } from '../widgets';

/**
 * Store for footer category. Stores array of menu items.
 * @category Store
 */
export class FooterStore extends CategoryStore<CategoryChildren> {
  static moduleName = 'FooterStore';

  @observable isReady = false;
  /**
   * list of menu items
   */
  @observable items: KuxMenuItem[];

  subMenus: KuxFilteredCategoriesDTO[] = [];
  type: UIDAStructureTypeEnum.menu = UIDAStructureTypeEnum.menu;
  subtype: UIDAPresentationTypeEnum.footer = UIDAPresentationTypeEnum.footer;

  constructor(props: KuxFilteredCategoriesDTO, parentCategoryTree: KuxFilteredCategoriesDTO, children: [] = []) {
    super(props);
    this.children = children;
    this.subMenus = props.children;
    this.items = [];
  }

  @action
  @errorHandling()
  async init() {
    const menuCategories = (this.subMenus && this.subMenus[0]?.children) || [];
    this.items = menuCategories
      .map((category) => {
        return parseMenuItemFromCategory(category, {
          includePresentationType: category.subtype && isNewSubtypeSupported(category.subtype),
        });
      })
      .filter(Boolean) as KuxMenuItem[];
    this.isReady = true;
  }
}
